import { ArrowUpCircleIcon } from '@heroicons/react/24/solid'
import ButtonEl from '../helpers/ctas/Button'
import themeConfig from '../../../theme.config'
import { useState, useEffect } from 'react'

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth', // for smoothly scrolling
  })
}

const BackToTop = (props) => {
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 300) {
        setShowButton(true)
      } else {
        setShowButton(false)
      }
    })
  }, [])

  return (
    <ButtonEl
      theme="text"
      buttonType="none"
      showDecorator={false}
      onClick={scrollToTop}
      className={`fixed z-[1000] !p-0 !shadow-2xl bottom-20 right-2 md:bottom-10 md:right-10 hover:scale-[1.1] ${showButton ? 'opacity-1' : 'opacity-0'}`}
    >
      <div className="rounded-full bg-white text-shadow-off shadow-2xl">
        <ArrowUpCircleIcon
          role="none"
          className={`w-12 h-12  text-${themeConfig.settings.backToTop ? themeConfig.settings.backToTop.replace('#', '') : 'light'}`}
        />
        <span className="sr-only">Back to top</span>
      </div>
    </ButtonEl>
  )
}

export default BackToTop
